<template>
  <div class="ota-simple-notification text-black rounded-6 py-5 px-4">
    <div class="flex mb-rem">
      <div>
        <OSvg :class="['w-6 mt-1 fill-current']" :svg="svg" />
      </div>
      <div class="pl-3">
        <p class="font-bold font-display text-sm" v-text="title || $t('Notification.FormAlreadyFilled')" />
      </div>
    </div>
    <p class="o-caption px-1" v-text="description || $t('Notification.CheckYourDetails')" />
  </div>
</template>

<script>
import OSvg from '@/components/OSvg'

export default {
  name: 'SimpleNotification',
  components: {
    OSvg
  },
  props: {
    svg: {
      type: String,
      default: 'checkmark'
    },
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    }
  }
}
</script>

<style scoped lang="postcss">
.ota-simple-notification {
  background-color: rgba(247, 159, 7, 1);

  &.rounded-6 {
    border-radius: .6rem;
  }

  .is-active-badge {
    height: 2.6rem;
    width: 2.6rem;

    svg {
      @apply absolute;
      top: 27%;
      left: 27%;
    }
  }
}
</style>
